import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import { Outlet } from "react-router-dom"

import { getAPITabsConfig } from "helpers/config/tabs/apiTabsConfig"
import PageTitle from "widgets/common/PageTitle"
import LinkTabsSection from "widgets/common/LinkTabsSection"
import useDocumentTitle from "helpers/hooks/useDocumentTitle"

export default function APIDocumentation() {
  const { t } = useTranslation()

  useDocumentTitle(t("pageTitles.API"))

  const APITabsConfig = useMemo(() => getAPITabsConfig(), [])

  return (
    <>
      <PageTitle text={t("pageTitles.API")} styles={{ mb: 2 }} />
      <LinkTabsSection tabsConfig={APITabsConfig} />
      <Outlet />
    </>
  )
}
